export { FingerPrint as default } from './FingerPrint';
